
export type SimpleGloss =
  | '.ADJ'  /** adjective */
  | '.ADV'  /** adverb */
  | '.N'    /** noun */
  | '.PREP' /** preposition */
  | '.V'    /** verb */
  | '.V.INTR' /** verb-intransitive */
  | '.V.PST'  /** verb-past */
  | '.V.TR'   /** verb-transitive */
  ;

/** words that vary pronunciation based on part-of-speech, specified by tacking on a gloss */
export const en_US_Varies: Record<string, string> = {
  "absent.adj": "/ˈæbsənt/",
  "absent.prep": "/ˈæbsənt/",
  "absent.v": "/æbˈsɛnt/",
  "abstract.adj": "/ˈæbˌstɹækt/", // or /ˌəbˈstɹækt/
  "abstract.n": "/ˈæbˌstɹækt/",
  "abstract.v": "/ˌəbˈstɹækt/", // or /ˈæbˌstɹækt/
  "abstracts.n": "/ˈæbˌstɹækts/",
  "abstracts.v": "/ˌəbˈstɹækts/", // or /ˈæbˌstɹækts/
  "abuse.n": "/əbˈjus/",
  "abuse.v": "/əbˈjuz/",
  "abuses.n": "/əbˈjusəz/",
  "abuses.v": "/əbˈjuzəz/",
  "addict.n": "/ˈæˌdɪkt/",
  "addict.v": "/əˈdɪkt/",
  "advocate.n": "/ˈædvəkət/",
  "advocate.v": "/ˈædvəˌkeɪt/",
  "affiliate.n": "/əˈfɪɫiət/",
  "affiliate.v": "/əˈfɪɫiˌeɪt/",
  "affix.n": "/ˈæfɪks/",
  "affix.v": "/əˈfɪks/",
  "agglomerate.adj": "/əˈɡɫɑmɝət/",
  "agglomerate.n": "/əˈɡɫɑmɝət/",
  "agglomerate.v": "/əˈɡɫɑmɝˌeɪt/",
  "aggregate.adj": "/ˈæɡɹəɡət/",
  "aggregate.n": "/ˈæɡɹəɡət/",
  "aggregate.v": "/ˈæɡɹəɡeɪt/",
  "ally.n": "/ˈæɫaɪ/",
  "ally.v": "/əˈɫaɪ/",
  "alternate.adj": "/ˈɔɫtɝˌnət/",
  "alternate.n": "/ˈɔɫtɝˌnət/",
  "alternate.v": "/ˈɔɫtɝˌneɪt/",
  "alternates.n": "/ˈɔɫtɝˌnəts/",
  "alternates.v": "/ˈɔɫtɝˌneɪts/",
  "animate.adj": "/ˈænəmət/",
  "animate.n": "/ˈænəˌmeɪt/",
  "annex.n": "/ˈæˌnɛks/",
  "annex.v": "/əˈnɛks/",
  "appropriate.adj": "/əˈpɹoʊpɹiˌeɪt/",
  "appropriate.v": "/əˈpɹoʊpɹiət/",
  "approximate.adj": "/əˈpɹɑksəˌmət/",
  "approximate.v": "/əˈpɹɑksəˌmeɪt/",
  "arithmetic.adj": "/ˌɛɹɪθˈmɛtɪk/",
  "arithmetic.n": "/əˈɹɪθməˌtɪk/",
  "articulate.adj": "/ɑɹˈtɪkjəɫət/",
  "articulate.v": "/ɑɹˈtɪkjəˌɫeɪt/",
  "associate.adj": "/əˈsoʊsiət/",
  "associate.n": "/əˈsoʊsiət/",
  "associate.v": "/əˈsoʊsiˌeɪt/",
  "attribute.n": "/ˈætɹəbˌjut/",
  "attribute.v": "/əˈtɹɪbjut/",
  "attributes.n": "/ˈætɹəbˌjuts/",
  "attributes.v": "/əˈtɹɪbjuts/",
  "buffet.adj": "/bəˈfeɪ/",
  "buffet.n": "/bəˈfeɪ/", // or /ˈbəfət/
  "buffet.v": "/ˈbəfət/",
  "buffets.n": "/bəˈfeɪz/", // or /ˈbəfəts/
  "buffets.v": "/ˈbəfəts/",
  "close.adj": "/ˈkɫoʊs/",
  "close.adv": "/ˈkɫoʊs/",
  "close.n": "/ˈkɫoʊz/",
  "close.v": "/ˈkɫoʊz/",
  "combat.adj": "/ˈkɑmbæt/",
  "combat.n": "/ˈkɑmbæt/",
  "combat.v": "/kəmˈbæt/",
  "combats.n": "/ˈkɑmbæts/",
  "combats.v": "/kəmˈbæts/",
  "combine.n": "/ˈkɑmbaɪn/",
  "combine.v": "/kəmˈbaɪn/", // or /ˈkɑmbaɪn/
  "commune.n": "/kəmˈjun/",
  "commune.v": "/ˈkɑmjun/",
  "compact.adj": "/kəmˈpækt/",
  "compact.n": "/ˈkɑmpækt",
  "compact.v": "/kəmˈpækt/",
  "complex.adj": "/kəmˈpɫɛks/",
  "complex.n": "/ˈkɑmpɫɛks/",
  "complex.v": "/kəmˈpɫɛks/",
  "complexes.n": "/ˈkɑmpɫɛksəz/",
  "complexes.v": "/kəmˈpɫɛksəz/",
  "compound.adj": "/ˈkɑmpaʊnd/",
  "compound.n": "/ˈkɑmpaʊnd/",
  "compound.v": "/kəmˈpaʊnd/",
  "compress.n": "/ˈkɑmpɹɛs/",
  "compress.v": "/kəmˈpɹɛs/",
  "concert.n": "/ˈkɑnsɝt/",
  "concert.v": "/kənˈsɝt/",
  "concrete.adj": "/kənˈkɹit/",
  "concrete.n": "/ˈkɑnkɹit/",
  "concrete.v": "/ˈkɑnkɹit/",
  "conduct.n": "/ˈkɑnˌdəkt/",
  "conduct.v": "/kənˈdəkt/",
  "confederate.adj": "/kənˈfɛdɝət/",
  "confederate.n": "/kənˈfɛdɝət/",
  "confederate.v": "/kənˈfɛdɝˌeɪt/",
  "confine.n": "/ˈkɑnˌfaɪn/",
  "confine.v": "/kənˈfaɪn/",
  "conflict.n": "/ˈkɑnfɫɪkt/",
  "conflict.v": "/kənˈfɫɪkt/",
  "conscript.adj": "/ˈkɑnsˌkɹɪpt/",
  "conscript.n": "/ˈkɑnsˌkɹɪpt/",
  "conscript.v": "/kənsˈkɹɪpt/",
  "construct.n": "/ˈkɑnstɹəkt/",
  "construct.v": "/kənˈstɹəkt/",
  "console.n": "/ˈkɑnsoʊɫ/",
  "console.v": "/kənˈsoʊɫ/",
  "consoles.n": "/ˈkɑnsoʊɫz/",
  "consoles.v": "/kənˈsoʊɫz/",
  "consummate.adj": "/ˈkɑnsəmət/",
  "consummate.v": "/ˈkɑnsəˌmeɪt/",
  "content.adj": "/kənˈtɛnt/",
  "content.n": "/ˈkɑntɛnt/", // or /kənˈtɛnt/
  "content.v": "/kənˈtɛnt/",
  "contents.n": "/ˈkɑntɛnts/", // or /kənˈtɛnts/
  "contents.v": "/kənˈtɛnts/",
  "contest.n": "/ˈkɑntɛst/",
  "contest.v": "/kənˈtɛst/",
  "contract.adj": "/ˈkɑnˌtɹækt/",
  "contract.n": "/ˈkɑnˌtɹækt/",
  "contract.v.intr": "/kənˈtɹækt/",
  "contract.v.tr": "/ˈkɑnˌtɹækt/",
  "contracts.n": "/ˈkɑnˌtɹækts/",
  "contracts.v.intr": "/kənˈtɹækts/",
  "contrast.n": "/ˈkɑntɹæst/",
  "contrast.v": "/kənˈtɹæst/",
  "converse.adj": "/kənˈvɝs/",
  "converse.n": "/ˈkɑnvɝs/",
  "converse.v": "/kənˈvɝs/",
  "convert.n": "/ˈkɑnvɝt/",
  "convert.v": "/kənˈvɝt/",
  "converts.n": "/ˈkɑnvɝts/",
  "converts.v": "/kənˈvɝts/",
  "convict.adj": "/kənˈvɪkt/",
  "convict.n": "/ˈkɑnvɪkt/",
  "convict.v": "/kənˈvɪkt/",
  "coordinate.adj": "/koʊˈɔɹdənət/",
  "coordinate.n": "/koʊˈɔɹdənət/",
  "coordinate.v": "/koʊˈɔɹdəˌneɪt/",
  "correlate.n": "/ˈkɔɹəɫət/",
  "correlate.v": "/ˈkɔɹəˌɫeɪt/",
  "decrease.n": "/ˈdiˌkɹis/", // or /dɪˈkɹis/
  "decrease.v": "/dɪˈkɹis/", // or /ˈdiˌkɹis/
  "defect.n": "/ˈdifɛkt/", // or /dɪˈfɛkt/
  "defect.v": "/dɪˈfɛkt/",
  "degenerate.adj": "/dɪˈdʒɛnɝət/",
  "degenerate.n": "/dɪˈdʒɛnɝət/",
  "degenerate.v": "/dɪˈdʒɛnɝˌeɪt/",
  "delegate.n": "/ˈdɛɫəɡət/",
  "delegate.v": "/ˈdɛɫəˌɡeɪt/",
  "deliberate.adj": "/dɪˈɫɪbɝˌət/",
  "deliberate.v": "/dɪˈɫɪbɝˌeɪt/",
  "desert.adj": "/ˈdɛzɝt/",
  "desert.n": "/ˈdɛzɝt/", // or /dɪˈzɝt/
  "desert.v": "/dɪˈzɝt/",
  "desolate.adj": "/ˈdɛsəɫət/",
  "desolate.v": "/ˈdɛsəˌɫeɪt/",
  "digest.n": "/ˈdaɪdʒɛst/",
  "digest.v": "/dəˈdʒɛst/",
  "discharge.v": "/dɪsˈtʃɑɹdʒ/",
  "discharge.n": "/ˈdɪsˌtʃɑɹdʒ/",
  "does.n": "/ˈdoʊz/",
  "does.v": "/ˈdəz/",
  "dove.n": "/ˈdəv/",
  "dove.v": "/ˈdoʊv/",
  "duplicate.adj": "/ˈdupɫəkət/",
  "duplicate.n": "/ˈdupɫəkət/",
  "duplicate.v": "/ˈdupɫəˌkeɪt/",
  "elaborate.adj": "/ɪˈɫæbɹət/",
  "elaborate.v": "/ɪˈɫæbɝˌeɪt/",
  "escort.n": "/ˈɛskɔɹt/",
  "escort.v": "/ɛˈskɔɹt/",
  "estimate.n": "/ˈɛstəmət/",
  "estimate.v": "/ˈɛstəˌmeɪt/",
  "estimates.n": "/ˈɛstəməts/",
  "estimates.v": "/ˈɛstəˌmeɪts/",
  "excerpt.n": "/ˈɛksɝpt/",
  "excerpt.v": "/ɛkˈsɝpt/",
  "expatriate.adj": "/ɛkˈspeɪtɹiət/",
  "expatriate.n": "/ɛkˈspeɪtɹiət/",
  "expatriate.v": "/ɛkˈspeɪtɹiˌeɪt/",
  "exploit.n": "/ˈɛksˌpɫɔɪt/",
  "exploit.v": "/ˌɛksˈpɫɔɪt/",
  "exploits.n": "/ˈɛksˌpɫɔɪts/",
  "exploits.v": "/ˌɛksˈpɫɔɪts/",
  "extract.n": "/ˈɛkˌstɹækt/",
  "extract.v": "/ɪkˈstɹækt/",
  "ferment.n": "/ˈfɝmɛnt/",
  "ferment.v": "/fɝˈmɛnt/",
  "geminate.adj": "/ˈdʒɛmənət/",
  "geminate.v": "/ˈdʒɛməˌneɪt/",
  "graduate.adj": "/ˈɡɹædʒəwət/",
  "graduate.n": "/ˈɡɹædʒəwət/",
  "graduate.v": "/ˈɡɹædʒəˌweɪt/",
  "graduates.n": "/ˈɡɹædʒəwəts/",
  "graduates.v": "/ˈɡɹædʒəˌweɪts/",
  "impact.n": "/ˈɪmpækt/",
  "impact.v": "/ˌɪmˈpækt/",
  "implant.n": "/ˈɪmˌpɫænt/",
  "implant.v": "/ˌɪmˈpɫænt/",
  "import.n": "/ˈɪmˌpɔɹt/",
  "import.v": "/ˌɪmˈpɔɹt/", // or /ˈɪmˌpɔɹt/
  "impress.n": "/ˈɪmˌpɹɛs/",
  "impress.v": "/ˌɪmˈpɹɛs/",
  "imprint.n": "/ˈɪmpɹɪnt/",
  "imprint.v": "/ˌɪmˈpɹɪnt/", // or /ˈɪmpɹɪnt/
  "incarnate.adj": "/ˌɪnˈkɑɹnət/",
  "incarnate.v": "/ˌɪnˈkɑɹˌneɪt/",
  "incline.n": "/ˈɪnkɫaɪn/",
  "incline.v": "/ˌɪnˈkɫaɪn/",
  "increase.n": "/ˈɪnˌkɹis/",
  "increase.v": "/ɪnˈkɹis/",
  "insert.n": "/ˈɪnˌsɝt/",
  "insert.v": "/ˌɪnˈsɝt/",
  "insult.n": "/ˈɪnˌsəɫt/",
  "insult.v": "/ɪnˈsəɫt/",
  "intimate.adj": "/ˈɪntəmət/",
  "intimate.n": "/ˈɪntəmət/",
  "intimate.v": "/ˈɪntəmeɪt/",
  "intrigue.n": "/ˈɪntɹiɡ/",
  "intrigue.v": "/ˌɪnˈtɹiɡ/",
  "invalid.adj": "/ɪnˈvæɫəd/", // or /ˈɪnvəɫəd/
  "invalid.n": "/ˈɪnvəɫəd/",
  "invalid.v": "/ˈɪnvəɫəd/",
  "laminate.adj": "/ˈɫæmənət/",
  "laminate.n": "/ˈɫæmənət/",
  "laminate.v": "/ˈɫæməˌneɪt/",
  "lead.adj": "/ˈɫid/",
  "lead.n": "/ˈɫɛd/", // or /ˈɫid/
  "lead.v": "/ˈɫid/", // or /ˈɫɛd/
  "leads.n": "/ˈɫɛds/", // or /ˈɫids/
  "leads.v": "/ˈɫids/", // or /ˈɫɛds/
  "learned.adj": "/ˈɫɝnəd/",
  "learned.v": "/ˈɫɝnd/",
  "live.adj": "/ˈɫaɪv/",
  "live.adv": "/ˈɫaɪv/",
  "live.v": "/ˈɫɪv/",
  "minute.adj": "/maɪˈnut/",
  "minute.n": "/ˈmɪnət/",
  "minute.v": "/ˈmɪnət/",
  "mismatch.n": "/ˈmɪsˌmætʃ/",
  "mismatch.v": "/mɪsˈmætʃ/",
  "moderate.adj": "/ˈmɑdɝət/",
  "moderate.n": "/ˈmɑdɝət/",
  "moderate.v": "/ˈmɑdɝˌeɪt/",
  "number.adj": "/ˈnəmɝ/",  // more numb
  "number.n": "/ˈnəmbɝ/",
  "number.v": "/ˈnəmbɝ/",
  "object.n": "/ˈɑbdʒɛkt/",
  "object.v": "/əbˈdʒɛkt/",
  "oblate.adj": "/ɑˈbɫeɪt/", // or /ˈɑbɫeɪt/
  "oblate.n": "/ˈɑbɫeɪt/",
  "overflow.n": "/ˈoʊvɝˌfɫoʊ/",
  "overflow.v": "/ˌoʊvɝˈfɫoʊ/",
  "perfect.adj": "/ˈpɝˌfɪkt/",
  "perfect.n": "/ˈpɝˌfɪkt/",
  "perfect.v": "/pɝˈfɛkt/",
  "permit.n": "/ˈpɝˌmɪt/",
  "permit.v": "/pɝˈmɪt/",
  "pervert.n": "/ˈpɝvɝt/",
  "pervert.v": "/pɝˈvɝt/",
  "polish.adj": "/ˈpoʊɫɪʃ/",
  "polish.n": "/ˈpɑɫɪʃ/", // or /ˈpoʊɫɪʃ/
  "polish.v": "/ˈpɑɫɪʃ/",
  "postulate.n": "/ˈpɑstʃəɫət/",
  "postulate.v": "/ˈpɑstʃəˌɫeɪt/",
  "predicate.adj": "/ˈpɹɛdɪkət/",
  "predicate.n": "/ˈpɹɛdɪkət/",
  "predicate.v": "/ˈpɹɛdəˌkeɪt/",
  "predominate.n": "/pɹɪˈdɑmənət/",
  "predominate.v": "/pɹɪˈdɑməˌneɪt/",
  "present.adj": "/ˈpɹɛzənt/",
  "present.n": "/ˈpɹɛzənt/",
  "present.v": "/pɹəˈzɛnt/",
  "presents.n": "/ˈpɹɛzənts/",
  "presents.v": "/pɹəˈzɛnts/",
  "produce.n": "/ˈpɹoʊdus/",
  "produce.v": "/pɹəˈdus/",
  "produces.n": "/ˈpɹoʊdusəz/",
  "produces.v": "/pɹəˈdusəz/",
  "progress.n": "/ˈpɹɑˌɡɹɛs/",
  "progress.v": "/pɹəˈɡɹɛs/",
  "project.n": "/ˈpɹɑdʒɛkt/",
  "project.v": "/pɹəˈdʒɛkt/",
  "projects.n": "/ˈpɹɑdʒɛkts/",
  "projects.v": "/pɹəˈdʒɛkts/",
  "protest.n": "/ˈpɹoʊˌtɛst/",
  "protest.v": "/pɹəˈtɛst/",
  "purport.n": "/ˈpɝˌpɔɹt/",
  "purport.v": "/pɝˈpɔɹt/",
  "radiate.adj": "/ˈɹeɪdiət/",
  "radiate.v": "/ˈɹeɪdiˌeɪt/",
  "read.adj": "/ˈɹɛd/",
  "read.n": "/ˈɹid/",
  "read.v": "/ˈɹid/",
  "read.v.pst": "/ˈɹɛd/",
  "rebel.adj": "/ˈɹɛbəɫ/",
  "rebel.n": "/ˈɹɛbəɫ/",
  "rebel.v": "/ɹəˈbɛɫ/",
  "rebels.n": "/ˈɹɛbəɫz/",
  "rebels.v": "/ɹəˈbɛɫz/",
  "recall.n": "/ˈɹiˌkɔɫ/",
  "recall.v": "/ɹɪˈkɔɫ/",
  "record.adj": "/ˈɹɛkɝd/",
  "record.n": "/ˈɹɛkɝd/",
  "record.v": "/ɹəˈkɔɹd/",
  "records.n": "/ˈɹɛkɝdz/",
  "records.v": "/ɹəˈkɔɹdz/",
  "refill.n": "/ˈɹifɪɫ/",
  "refill.v": "/ɹiˈfɪɫ/",
  "refund.n": "/ˈɹiˌfənd/",
  "refund.v": "/ɹɪˈfənd/",
  "refuse.n": "/ˈɹɛfˌjuz/",
  "refuse.v": "/ˌɹiˈfjuz/",
  "regress.n": "/ˈɹiɡɹɛs/",
  "regress.v": "/ɹɪˈɡɹɛs/",
  "reject.n": "/ˈɹidʒɛkt/",
  "reject.v": "/ɹɪˈdʒɛkt/",
  "rejects.n": "/ˈɹidʒɛkts/",
  "rejects.v": "/ɹɪˈdʒɛkts/",
  "remake.n": "/ˈɹiˌmeɪk/",
  "remake.v": "/ˌɹiˈmeɪk/",
  "remakes.n": "/ˈɹiˌmeɪks/",
  "remakes.v": "/ˌɹiˈmeɪks/",
  "remediate.adj": "/ɹiˈmidiət/",
  "remediate.v": "/ɹiˈmidiˌeɪt/",
  "reset.n": "/ˈɹisɛt/",
  "reset.v": "/ɹiˈsɛt/",
  "reverberate.adj": "/ɹɪˈvɝbɝət/",
  "reverberate.v": "/ɹɪˈvɝbɝeɪt/",
  "rewrite.n": "/ˈɹiˌɹaɪt/",
  "rewrite.v": "/ɹiˈɹaɪt/",
  // row.n & row.v can both be /ˈɹoʊ/ or /ˈɹaʊ/
  "separate.adj": "/ˈsɛpɝət/",
  "separate.n": "/ˈsɛpɝət/",
  "separate.v": "/ˈsɛpɝˌeɪt/",
  // sewer.n can be /ˈsuɝ/ or /ˈsoʊɝ/
  "sophisticate.n": "/səˈfɪstəkət/",
  "sophisticate.v": "/səˈfɪstəˌkeɪt/",
  "sow.n": "/ˈsaʊ/",
  "sow.v": "/ˈsoʊ/",
  "subject.adj": "/ˈsəbdʒɪkt/",
  "subject.n": "/ˈsəbdʒɪkt/",
  "subject.v": "/səbˈdʒɛkt/",
  "subordinate.adj": "/səˈbɔɹdənət/",
  "subordinate.n": "/səˈbɔɹdənət/",
  "subordinate.v": "/səˈbɔɹdəˌneɪt/",
  "surrogate.n": "/ˈsɝəɡət/",
  "surrogate.v": "/ˈsɝəˌɡeɪt/",
  "survey.n": "/ˈsɝˌveɪ/",
  "survey.v": "/sɝˈveɪ/", // or /ˈsɝˌveɪ/
  "suspect.adj": "/ˈsəsˌpɛkt/", // or /səˈspɛkt/
  "suspect.n": "/ˈsəsˌpɛkt/",
  "suspect.v": "/səˈspɛkt/",
  "syndicate.n": "/ˈsɪndəˌkət/",
  "syndicate.v": "/ˈsɪndəˌkeɪt/",
  "syndicates.n": "/ˈsɪndəˌkəts/",
  "syndicates.v": "/ˈsɪndəˌkeɪts/",
  // tear.n & tear.v can both be /ˈtɛɹ/ or /ˈtɪɹ/
  "torment.n": "/ˈtɔɹˌmɛnt/",
  "torment.v": "/tɔɹˈmɛnt/", // or /ˈtɔɹˌmɛnt/
  "transfer.n": "/ˈtɹænsfɝ/",
  "transfer.v": "/tɹænsˈfɝ/", // or /ˈtɹænsfɝ/
  "transform.n": "/ˈtɹænsfɔɹm/",
  "transform.v": "/tɹænsˈfɔɹm/",
  "transport.n": "/ˈtɹænspɔɹt/",
  "transport.v": "/tɹænˈspɔɹt/", // or /ˈtɹænspɔɹt/
  "underestimate.n": "/ˈəndɝˈɛstəmət/",
  "underestimate.v": "/ˈəndɝˈɛstəˌmeɪt/",
  "upset.adj": "/əpˈsɛt/",
  "upset.n": "/ˈəpˌsɛt/",
  "upset.v": "/əpˈsɛt/",
  "use.n": "/ˈjus/",
  "use.v": "/ˈjuz/",
  "uses.n": "/ˈjusəz/",
  "uses.v": "/ˈjuzəz/",
  "wind.n": "/ˈwɪnd/", // or /ˈwaɪnd/
  "wind.v": "/ˈwaɪnd/", // or /ˈwɪnd/
  "winds.n": "/ˈwɪndz/", // or /ˈwaɪndz/
  "winds.v": "/ˈwaɪndz/", // or /ˈwɪndz/
  "wound.n": "/ˈwund/",
  "wound.v": "/ˈwund/",
  "wound.v.pst": "/ˈwaʊnd/",
}
